import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';
import getUsuario from '../../graphql/querys/auth/getUsuario.graphql';
import Loading from '../common/LegacyLoading';

import SinPermisos from '../common/SinPermisos';

@graphql(getUsuario)
class RutaAutenticada extends React.Component {
  constructor(props) {
    super(props);

    this.renderRuta = this.renderRuta.bind(this);
  }

  renderRuta(props) {
    // console.log("Entre al renderizar ruta con...");
    // console.log(this.props);
    const { data } = this.props;
    data.loading = data.loading || false;
    if (data.loading) {
      // console.log("ESTOY POR RENDERIZAR RUTA Y QUEDE CARGANDO")
      return <Loading />;
    }

    const Component = this.props.component;
    // console.log("Llegue a la previa de renderizar el componente parametrizado");
    // console.log(data);

    if (data.getUsuario && !data.getUsuario.activado) {
      //Caso en que la cuenta este creada, pero no activada por un supervisor.

      return (
        <div style={{ textAlign: 'center', margin: '20%' }}>
          <h2>
            Su cuenta no se encuentra activada. Comuniquese con un supervisor
          </h2>
        </div>
      );
    }

    let usuario = data.getUsuario;

    let autorizado = false;

    if (this.props.rolesAutorizados) {
      //Si esto existe, significa que existe una restriccion de usuarios.
      autorizado = this.props.rolesAutorizados.includes(usuario.rol);
    } else {
      //Como no existe una restriccion, todos los usuarios pueden ver dicha ruta.
      autorizado = true;
    }

    if (usuario && usuario.activado) {
      if (autorizado) {
        return <Component usuario={data.getUsuario} {...props} />;
      }
      if (!autorizado) {
        return <SinPermisos />;
      }
    }

    return <Redirect to="/login" />;
  }

  render() {
    const { component, ...resto } = this.props;
    return <Route {...resto} render={this.renderRuta} />;
  }
}

RutaAutenticada.propTypes = {
  component: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default RutaAutenticada;
